var _path, _circle, _path2, _path3, _polygon, _path4, _polygon2, _path5, _path6, _path7, _path8, _path9, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _path10, _path11, _path12, _path13, _path14, _path15, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _ellipse40, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 356.3573,
    height: 578.27325,
    viewBox: "0 0 356.3573 578.27325",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M529.96429,271.023c-1.85286,7.35735-7.89056,22.15132-7.94354,29.7812l.41737-.53928a34.09917,34.09917,0,0,0,3.72993,4.04055,21.90272,21.90272,0,0,1,6.68115-6.06947,26.21866,26.21866,0,0,0-1.23234,10.3204c4.25322,8.94314,17.47476,2.90571,25.41426.78675,9.3214,8.13092,20.3814,9.07981,33.7146,1.86418,3.98574-.12966,8.4193-.48221,10.858-3.17932s-10.246-16.48828-9.20629-19.943c7.40567-24.60821,6.987-21.93175-2.71826-31.31421-2.13576-2.06474-2.59724-5.51651-5.11347-7.42143-3.49088-2.64006-8.33262-2.93988-12.78106-3.10256a6.64655,6.64655,0,0,0,5.39622-3.64942,5.99594,5.99594,0,0,0-.92173-6.19056c-1.90461-2.36555-5.33818-3.42495-8.50507-3.37569a30.27478,30.27478,0,0,0-9.03606,2.02883,16.51031,16.51031,0,0,0-5.296,2.52231,4.57248,4.57248,0,0,0-1.73458,4.91284,5.92357,5.92357,0,0,0,3.97923,3.269,15.50488,15.50488,0,0,0,4.0698.54071,31.0643,31.0643,0,0,0-17.6254,5.61463C535.65086,256.58168,531.82724,263.66807,529.96429,271.023Z",
    transform: "translate(-421.82135 -160.86337)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 569.61173,
    cy: 280.11102,
    r: 25.12711,
    transform: "translate(-257.63138 607.66644) rotate(-76.49097)",
    fill: "#ffb6b6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M552.83874,270.018c2.03679,4.16674,6.35327,5.01186,10.2856,5.37035,1.24038.11677,2.4856.21344,3.738.27982.37386-.62435.77792-1.24143,1.20734-1.8311a21.90266,21.90266,0,0,1,6.68115-6.06945,25.812,25.812,0,0,0-1.30519,8.13913q3.52584.03162,7.06511-.12535a7.934,7.934,0,0,0,8.46313-6.92043c2.59337,3.18123,5.54636,6.10777,9.16454,7.01966,4.22392.89954-2.459-1.05851-.35322-4.82893,1.71389-2.786,2.40045-6.30911,2.78175-9.671.44841-3.996.38414-8.52029-1.86072-10.71177-1.80117-1.77577-8.89519,3.90872-11.30882,4.41609-5.32382,1.14406,4.9317-2.52822-.04648-.32153l-.30458,1.046c.1633-5.47154-2.46836-10.35678-6.29161-11.70165-2.57735-.89633-5.45013-.29675-8.23467.33469a37.39133,37.39133,0,0,0-10.33722,3.49631,20.58,20.58,0,0,0-8.57731,8.99285C551.62018,261.07005,551.08119,266.41935,552.83874,270.018Z",
    transform: "translate(-421.82135 -160.86337)",
    fill: "#2f2e41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M576.16978,241.92174c-.25552-.03913.39366-.03249.17372.00344a2.048,2.048,0,0,0,.31964-.08992c.01773-.00612.25484-.11892.09809-.0384a2.01721,2.01721,0,0,0,.86551-.74894,8.35646,8.35646,0,0,0,1.02879-2.60005,8.75429,8.75429,0,0,1,1.44325-3.36548,2.15456,2.15456,0,0,1,3.47709.05688c.63043,1.00676.3675,2.38853.16477,3.48907a10.80241,10.80241,0,0,1-1.15837,3.26373,9.87908,9.87908,0,0,1-4.05,3.91218,10.3337,10.3337,0,0,1-6.41062,1.05877,1.56955,1.56955,0,0,1-.44893-2.83728l3.32186-1.91806a1.55464,1.55464,0,1,1,1.62419,2.65135l-3.32187,1.918-.44893-2.83728a6.18242,6.18242,0,0,0,1.37778.04718,5.2055,5.2055,0,0,0,1.4501-.25976,6.45363,6.45363,0,0,0,1.30479-.51255,8.88046,8.88046,0,0,0,.77436-.46q.13625-.09069.26917-.18644c-.00637.0046.37055-.28937.20623-.153a8.76777,8.76777,0,0,0,1.14-1.16654,3.53892,3.53892,0,0,0,.3246-.47753,8.2304,8.2304,0,0,0,.45153-.84741,8.075,8.075,0,0,0,.571-1.92169,8.18209,8.18209,0,0,0,.11555-.84384,3.36867,3.36867,0,0,1,.02084-.45853c.08288-.36828.003.20805.17385.33952l.71337.38967a.85447.85447,0,0,0,.70895-.21456q.09318-.17782-.04306.06064a5.07466,5.07466,0,0,0-.27983.579,14.67633,14.67633,0,0,0-.44841,1.42021,14.77972,14.77972,0,0,1-1.08484,2.95493,5.00542,5.00542,0,0,1-5.15042,2.81588,1.56718,1.56718,0,0,1-1.14846-1.87478A1.58645,1.58645,0,0,1,576.16978,241.92174Z",
    transform: "translate(-421.82135 -160.86337)",
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "145.159 555.251 156.689 555.25 162.174 510.779 145.157 510.779 145.159 555.251",
    fill: "#ffb6b6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M582.34688,717.15172v-7.81624l-3.031.18517-12.33831.731-2.85555.17542-2.18307,26.17758L561.822,738.008h8.18654l.26316-1.39366,1.189-6.33485,3.07,6.33485.67247,1.39366h21.70418a4.90408,4.90408,0,0,0,4.873-4.88272C602.69637,728.84683,584.64691,719.598,582.34688,717.15172Z",
    transform: "translate(-421.82135 -160.86337)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "16.8 541.356 26.293 547.899 56.048 514.396 42.037 504.74 16.8 541.356",
    fill: "#ffb6b6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M450.68405,711.79473l4.43594-6.43554-2.6007-1.56773L441.94567,697.391l-2.45068-1.47618-16.654,20.31446-.89277,1.08913,6.74042,4.6461,1.00761-.99813,4.57415-4.541-1.06752,6.95813-.23726,1.52912,17.87022,12.31774a4.904,4.904,0,0,0,6.78325-1.25466C460.80157,732.97285,451.18947,715.11417,450.68405,711.79473Z",
    transform: "translate(-421.82135 -160.86337)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M725.76073,263.98546a8.18914,8.18914,0,0,1-10.65658,4.111,7.857,7.857,0,0,1-1.13848-.625l-49.49522,37.49772-15.55139-13.16714,63.26538-35.82357a8.16642,8.16642,0,0,1,9.65468-2.48742,7.81523,7.81523,0,0,1,4.01066,10.299Q725.8066,263.88841,725.76073,263.98546Z",
    transform: "translate(-421.82135 -160.86337)",
    fill: "#ffb6b6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M580.41187,369.29973s-17.49171-4.46325-5.2384-27.43336,59.38108-48.585,62.643-48.90394.61571,2.7893,6.26641-2.334c4.59575-4.16683,6.47695-.198,6.64773-2.22406.45035-5.34258,7.41715,3.75669,6.492-2.80641s14.816,14.54747,14.816,14.54747-.00477,3.91289-8.27249,7.08742c-4.64364,1.783-7.88313.27247-7.77392,4.26722s-9.41543,2.50046-10.6495,3.374-22.06308,28.62759-22.06308,28.62759Z",
    transform: "translate(-421.82135 -160.86337)",
    fill: "#c1121f"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M745.85321,343.06736c-21.38195-5.32231-39.73961-15.78432-54.091-33.05485a4.84486,4.84486,0,0,1-1.60592-6.65283L715.12,262.509a4.84486,4.84486,0,0,1,6.65282-1.60591l54.091,33.05486a4.84486,4.84486,0,0,1,1.606,6.65281l-24.96376,40.85072A4.84486,4.84486,0,0,1,745.85321,343.06736Z",
    transform: "translate(-421.82135 -160.86337)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M731.43035,329.94991c-11.25812-1.229-22.95866-10.227-34.77461-21.25065a4.53727,4.53727,0,0,1-1.504-6.23059L716.606,267.36092a4.53745,4.53745,0,0,1,6.23069-1.50419l48.13364,29.41432a4.53747,4.53747,0,0,1,1.50388,6.23078l-13.29046,21.74852A20.21112,20.21112,0,0,1,731.43035,329.94991Z",
    transform: "translate(-421.82135 -160.86337)",
    fill: "#fff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 746.76119,
    cy: 293.33269,
    rx: 3.60114,
    ry: 5.17661,
    transform: "translate(-142.8515 784.288) rotate(-75.77932)",
    fill: "#fff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 712.91756,
    cy: 293.11453,
    rx: 3.60114,
    ry: 5.17661,
    transform: "translate(-168.16972 751.31689) rotate(-75.77932)",
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 753.11218,
    cy: 321.41114,
    rx: 3.60114,
    ry: 5.17661,
    transform: "translate(-165.27872 811.62515) rotate(-75.77932)",
    fill: "#ff6584"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 763.75764,
    cy: 333.01776,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-73.83478 894.2077) rotate(-83.62433)",
    fill: "#e6e6e6"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 766.54056,
    cy: 354.22561,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-92.43757 915.82619) rotate(-83.62433)",
    fill: "#3f3d56"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 731.94027,
    cy: 313.80968,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-83.02963 845.51204) rotate(-83.62433)",
    fill: "#e6e6e6"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 748.97198,
    cy: 307.41122,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-61.53037 856.75048) rotate(-83.62433)",
    fill: "#ff6584"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 727.98967,
    cy: 290.12471,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-63.00306 820.53104) rotate(-83.62433)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M624.0841,465.48668l.297-3.11895-12.82393-35.15788-54.65065,10.53791s-28.16648,34.69834-21.903,57.66443c1.69865,6.22839-19.67434,47.596-12.6402,43.13436s-7.316,7.95691-3.64093,8.24766-2.09631,4.62059-3.1894,6.98148c-25.17394,54.37159-65.43442,125.36525-65.43442,125.36525s8.37323,23.5394,21.58517,10.37782S573.28032,559.43888,573.28032,559.43888s-1.19115,7.6121-2.85225,19.18556c-5.13173,35.75456-13.19255,107.73389-6.03064,111.46052a36.32076,36.32076,0,0,0,18.54936,4.018S630.34758,584.4928,624.0841,563.61453",
    transform: "translate(-421.82135 -160.86337)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M591.77,318.84909l-5.08631-10.57278L559.12643,311.615l-2.84945,8.626a100.04967,100.04967,0,0,0-19.45622,27.4243c-7.62525,16.28927,17.75232,88.244,13.57667,92.41968s-19.64741,6.42562-12.688,11.54107,0,1.844-1.73437,7.68013-5.1493,29.06484-5.1493,29.06484,26.49512,22.21017,43.19774-11.195c24.358,2.08782,29.22957-20.87827,29.22957-20.87827l8.18883-13.56268c10.62463-4.86335-5.753-60.55517-1.57738-71.69024S591.77,318.84909,591.77,318.84909Z",
    transform: "translate(-421.82135 -160.86337)",
    fill: "#c1121f"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M616.95465,438.06781c.06315-4.09006.05084-8.49452,1.867-12.26317,1.36418-2.8308,3.89625-5.65828,7.23268-5.89508,2.83674-.20134,6.05694,1.47615,6.318,4.55982.31031,3.66531-2.776,7.16673-5.275,9.48083a24.13131,24.13131,0,0,1-10.68079,5.69036,1.51636,1.51636,0,0,0-.35832,2.74162,28.19471,28.19471,0,0,1,8.26147,6.92434c2.10811,2.60395,4.2878,6.04265,4.73286,9.43112.18961,1.44366-.06647,3.19873-1.595,3.802-1.45172.573-3.21824-.17342-4.46373-.91116a18.04276,18.04276,0,0,1-6.605-7.95147,20.3924,20.3924,0,0,1-1.647-11.75362c.30955-1.88862-2.58084-2.70107-2.89284-.79751-1.37458,8.38662,1.97214,18.37406,9.47569,22.9975,3.41425,2.10374,8.62232,2.47326,10.33647-1.96636,1.55292-4.022-1.01659-8.855-3.16364-12.16331a30.96315,30.96315,0,0,0-10.92521-10.202l-.35832,2.74163a27.27588,27.27588,0,0,0,11.71768-6.20024c3.19267-2.8669,6.63066-7.12316,6.45339-11.66687-.15934-4.08406-3.42237-7.04557-7.33427-7.6427-4.25323-.64924-8.04845,1.66789-10.48546,5.0281-3.34278,4.60912-3.52626,10.545-3.61074,16.01611a1.50091,1.50091,0,0,0,3,0Z",
    transform: "translate(-421.82135 -160.86337)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M495.12219,495.35139a8.18913,8.18913,0,0,0,3.57949-10.84668,7.85633,7.85633,0,0,0-.68048-1.10621L533.02763,432.111l-13.91944-14.88183-32.654,64.9581a8.16642,8.16642,0,0,0-2.00736,9.76579,7.81523,7.81523,0,0,0,10.48463,3.4969Q495.02753,495.402,495.12219,495.35139Z",
    transform: "translate(-421.82135 -160.86337)",
    fill: "#ffb6b6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M593.12634,344.97662s-5.322-17.24982-27.65867-3.87656-45.59169,61.70908-45.74911,64.98273,2.81632.47714-2.02156,6.37408c-3.93467,4.796.12225,6.47882-1.89289,6.7495-5.3138.71377,4.11857,7.22248-2.48222,6.62273s15.26174,14.07915,15.26174,14.07915,3.90788-.1981,6.67-8.61258c1.55139-4.72606-.11736-7.887,3.87791-7.97525s2.0322-9.52748,2.84366-10.8032,27.50252-23.45058,27.50252-23.45058Z",
    transform: "translate(-421.82135 -160.86337)",
    fill: "#c1121f"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M558.1691,259.87515c16.42407-18.94122-12.77167,31.20981,9.03933,50.76069-8.88958,7.05334-41.496,4.55085-39.65352,0s7.88189-47.97051,14.3622-50.76069S558.1691,259.87515,558.1691,259.87515Z",
    transform: "translate(-421.82135 -160.86337)",
    fill: "#2f2e41"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 530.76119,
    cy: 496.33269,
    rx: 3.60114,
    ry: 5.17661,
    transform: "translate(-502.56895 728.03852) rotate(-75.77932)",
    fill: "#fff"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 496.91756,
    cy: 496.11453,
    rx: 3.60114,
    ry: 5.17661,
    transform: "translate(-527.88717 695.0674) rotate(-75.77932)",
    fill: "#3f3d56"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 537.11218,
    cy: 524.41114,
    rx: 3.60114,
    ry: 5.17661,
    transform: "translate(-524.99617 755.37567) rotate(-75.77932)",
    fill: "#ff6584"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 547.75764,
    cy: 536.01776,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-467.59311 860.0011) rotate(-83.62433)",
    fill: "#e6e6e6"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 550.54056,
    cy: 557.22561,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-486.1959 881.61958) rotate(-83.62433)",
    fill: "#3f3d56"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 515.94027,
    cy: 516.80968,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-476.78797 811.30543) rotate(-83.62433)",
    fill: "#e6e6e6"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 532.97198,
    cy: 510.41122,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-455.2887 822.54387) rotate(-83.62433)",
    fill: "#ff6584"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 511.98967,
    cy: 493.12471,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-456.76139 786.32444) rotate(-83.62433)",
    fill: "#3f3d56"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 729.76119,
    cy: 446.33269,
    rx: 3.60114,
    ry: 5.17661,
    transform: "translate(-303.98691 883.22338) rotate(-75.77932)",
    fill: "#fff"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 695.91756,
    cy: 446.11453,
    rx: 3.60114,
    ry: 5.17661,
    transform: "translate(-329.30513 850.25226) rotate(-75.77932)",
    fill: "#3f3d56"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 736.11218,
    cy: 474.41114,
    rx: 3.60114,
    ry: 5.17661,
    transform: "translate(-326.41413 910.56052) rotate(-75.77932)",
    fill: "#ff6584"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 746.75764,
    cy: 486.01776,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-241.0007 1013.32266) rotate(-83.62433)",
    fill: "#e6e6e6"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 749.54056,
    cy: 507.22561,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-259.60349 1034.94115) rotate(-83.62433)",
    fill: "#3f3d56"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 714.94027,
    cy: 466.80968,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-250.19556 964.627) rotate(-83.62433)",
    fill: "#e6e6e6"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 731.97198,
    cy: 460.41122,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-228.69629 975.86543) rotate(-83.62433)",
    fill: "#ff6584"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 710.98967,
    cy: 443.12471,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-230.16898 939.646) rotate(-83.62433)",
    fill: "#3f3d56"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 460.76119,
    cy: 296.33269,
    rx: 3.60114,
    ry: 5.17661,
    transform: "translate(-361.50159 509.315) rotate(-75.77932)",
    fill: "#fff"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 426.91756,
    cy: 296.11453,
    rx: 3.60114,
    ry: 5.17661,
    transform: "translate(-386.81981 476.34389) rotate(-75.77932)",
    fill: "#3f3d56"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 467.11218,
    cy: 324.41114,
    rx: 3.60114,
    ry: 5.17661,
    transform: "translate(-383.92881 536.65215) rotate(-75.77932)",
    fill: "#ff6584"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 477.75764,
    cy: 336.01776,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-331.0568 612.64343) rotate(-83.62433)",
    fill: "#e6e6e6"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 480.54056,
    cy: 357.22561,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-349.65958 634.26191) rotate(-83.62433)",
    fill: "#3f3d56"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 445.94027,
    cy: 316.80968,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-340.25165 563.94776) rotate(-83.62433)",
    fill: "#e6e6e6"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 462.97198,
    cy: 310.41122,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-318.75238 575.1862) rotate(-83.62433)",
    fill: "#ff6584"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 441.98967,
    cy: 293.12471,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-320.22508 538.96677) rotate(-83.62433)",
    fill: "#3f3d56"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 619.76119,
    cy: 167.33269,
    rx: 3.60114,
    ry: 5.17661,
    transform: "translate(-116.51408 566.13251) rotate(-75.77932)",
    fill: "#fff"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 585.91756,
    cy: 167.11453,
    rx: 3.60114,
    ry: 5.17661,
    transform: "translate(-141.83229 533.1614) rotate(-75.77932)",
    fill: "#3f3d56"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 626.11218,
    cy: 195.41114,
    rx: 3.60114,
    ry: 5.17661,
    transform: "translate(-138.94129 593.46966) rotate(-75.77932)",
    fill: "#ff6584"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 636.75764,
    cy: 207.01776,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-61.5111 655.98509) rotate(-83.62433)",
    fill: "#e6e6e6"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 639.54056,
    cy: 228.22561,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-80.11389 677.60358) rotate(-83.62433)",
    fill: "#3f3d56"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 604.94027,
    cy: 187.80968,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-70.70596 607.28943) rotate(-83.62433)",
    fill: "#e6e6e6"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 621.97198,
    cy: 181.41122,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-49.20669 618.52787) rotate(-83.62433)",
    fill: "#ff6584"
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 600.98967,
    cy: 164.12471,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-50.67939 582.30844) rotate(-83.62433)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M667.26676,721.80367a2.26935,2.26935,0,0,0,1.64469-3.93333l-.1555-.61819q.03071-.07427.06178-.14839a6.09416,6.09416,0,0,1,11.24139.04177c1.83859,4.42817,4.17942,8.86389,4.75579,13.54594a18.02871,18.02871,0,0,1-.31648,6.20047,72.28153,72.28153,0,0,0,6.57515-30.02077,69.76619,69.76619,0,0,0-.43274-7.783q-.3585-3.17779-.99471-6.31033A73.11887,73.11887,0,0,0,675.146,661.78827a19.459,19.459,0,0,1-8.093-8.39652,14.84349,14.84349,0,0,1-1.34991-4.05618c.394.05168,1.48556-5.94866,1.1884-6.3168.54906-.83317,1.53178-1.24732,2.13144-2.06034,2.98232-4.0434,7.0912-3.33741,9.2362,2.15727,4.58224,2.31266,4.6266,6.14806,1.815,9.83683-1.78878,2.34681-2.03456,5.52232-3.60409,8.03478.16151.20671.32945.407.4909.61366a73.59114,73.59114,0,0,1,7.681,12.16859A30.59253,30.59253,0,0,1,686.46841,659.56c1.74819-4.21732,5.02491-7.76916,7.91045-11.415a6.27922,6.27922,0,0,1,11.184,3.08333q.00887.08063.01731.16119-.6429.36267-1.25864.76992a3.0782,3.0782,0,0,0,1.24107,5.60174l.06277.00968a30.62792,30.62792,0,0,1-.80734,4.57937c3.70179,14.31579-4.29012,19.5299-15.70148,19.76413-.2519.12916-.49738.25832-.74928.38108a75.11456,75.11456,0,0,1,4.04326,19.02779,71.24344,71.24344,0,0,1-.05168,11.50323l.01939-.13562a18.82566,18.82566,0,0,1,6.4266-10.87028c4.94561-4.06264,11.93283-5.55869,17.26826-8.82425a3.533,3.533,0,0,1,5.41121,3.43708l-.02182.14261a20.67541,20.67541,0,0,0-2.31871,1.11733q-.6429.36276-1.25864.76992a3.07824,3.07824,0,0,0,1.24108,5.6018l.06282.00964c.04519.00646.084.013.12911.01944a30.65462,30.65462,0,0,1-5.63854,8.82922c-2.31464,12.49713-12.256,13.68283-22.89023,10.04354h-.00648a75.09193,75.09193,0,0,1-5.0444,14.72621H667.71833c-.06464-.20022-.12274-.40693-.1809-.60717a20.47486,20.47486,0,0,0,4.9863-.297c-1.337-1.64059-2.674-3.29409-4.011-4.93462a1.119,1.119,0,0,1-.084-.09689c-.67817-.8396-1.36282-1.67283-2.041-2.51246l-.00037-.001a29.99051,29.99051,0,0,1,.87876-7.63985Z",
    transform: "translate(-421.82135 -160.86337)",
    fill: "#f2f2f2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M465.71541,737.94662a1.18647,1.18647,0,0,0,1.19007,1.19h253.29a1.19,1.19,0,1,0,0-2.38h-253.29A1.18651,1.18651,0,0,0,465.71541,737.94662Z",
    transform: "translate(-421.82135 -160.86337)",
    fill: "#ccc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.8ce2bd010e4c8ac3f08f0ab4d15854f1.svg";
export { ForwardRef as ReactComponent };